import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import {
  getClientJourneyAllTasks,
  getClientJourneyTasks,
  getFirstOrder,
} from '/redux/action/client.action';
import {
  clientJourneyTasksById,
  firstOrderPackagesById,
  firstOrderShippingStatusById,
  hasAllTasks,
  hasFirstOrderById,
  hasFirstWeekTasks,
  hasPreJourneyTasks,
  hasWeeklyCheckInsTasks,
  isEmptyAllTasks,
} from '/redux/selector/client.selector';
import {currentScreen} from '/redux/selector/navigation.selector';
import {variablesCodeConfigs} from '/redux/selector/remoteConfig.selector';
import {getDateUtilDefaultInstance} from '/util/date.util';

import {ClientJourney} from './ClientJourney';

export default connect(
  createStructuredSelector({
    hasAllTasks,
    hasFirstWeekTasks,
    hasPreJourneyTasks,
    hasWeeklyCheckInsTasks,
    hasFirstOrder: hasFirstOrderById,
    firstOrderShippingStatus: firstOrderShippingStatusById,
    currentScreen,
    isEmptyAllTasks,
    firstOrderPackages: firstOrderPackagesById,
    codeConfigs: variablesCodeConfigs,
    clientJourneyTaskData: clientJourneyTasksById,
  }),
  dispatch => ({
    getClientJourneyAllTasks: ({clientId}: any) =>
      // @ts-expect-error TS(2345): Argument of type '{ (dispatch: any, getState: any)... Remove this comment to see the full error message
      dispatch(getClientJourneyAllTasks({clientId})),
    getClientJourneyTasks: ({type, clientId, currentDate}: any) =>
      // @ts-expect-error TS(2345): Argument of type '{ (dispatch: any, getState: any)... Remove this comment to see the full error message
      dispatch(getClientJourneyTasks({type, clientId, currentDate})),
    getFirstOrder: ({firstOrderId}: any) =>
      // @ts-expect-error TS(2345): Argument of type '{ (dispatch: any, getState: any)... Remove this comment to see the full error message
      dispatch(getFirstOrder({firstOrderId})),
  }),
  (stateProps, dispatchProps, ownProps) => ({
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
    getClientJourneyAllTasks: () => {
      const {clientId} = ownProps;
      return dispatchProps.getClientJourneyAllTasks({
        clientId,
      });
    },
    getClientJourneyTasks: ({type}: any) => {
      const {clientId} = ownProps;
      const currentTime = getDateUtilDefaultInstance().getNow();
      const currentDate = Math.round(
        getDateUtilDefaultInstance().getEpoch(currentTime) * 1000,
      );
      return dispatchProps.getClientJourneyTasks({
        type,
        clientId,
        currentDate,
      });
    },
  }),
)(ClientJourney);
